var render = function render(){
  var _vm$kanbanData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [(_vm$kanbanData = _vm.kanbanData) !== null && _vm$kanbanData !== void 0 && _vm$kanbanData.length ? _c('div', {
    staticClass: "kanban-board"
  }, [_c('draggable', {
    staticClass: "kanban-container",
    attrs: {
      "group": {
        name: 'stages',
        pull: ['stages'],
        put: ['stages']
      },
      "direction": "horizontal",
      "animation": 200
    },
    on: {
      "end": _vm.onStageReorder
    },
    model: {
      value: _vm.stages,
      callback: function callback($$v) {
        _vm.stages = $$v;
      },
      expression: "stages"
    }
  }, _vm._l(_vm.kanbanData, function (stage) {
    return _c('div', {
      key: stage.id,
      staticClass: "kanban-column"
    }, [_c('div', {
      staticClass: "kanban-header d-flex justify-content-between align-items-center mb-2"
    }, [_c('h5', {
      staticClass: "kanban-title mb-0"
    }, [_vm._v(_vm._s(stage.title))]), _c('b-dropdown', {
      attrs: {
        "size": "sm",
        "variant": "light",
        "right": "",
        "no-caret": ""
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function fn() {
          return [_c('span', {
            staticClass: "d-inline-flex align-items-center"
          }, [_c('i', {
            staticClass: "fa fa-cog mr-1"
          }), _c('span', [_vm._v("Setting")])])];
        },
        proxy: true
      }], null, true)
    }, [_c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.$emit('onDenied', stage.id);
        }
      }
    }, [_vm._v(" Set Denied Process ")]), _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.$emit('onSpalProcess', stage.id);
        }
      }
    }, [_vm._v(" Set SPAL Process ")]), _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.$emit('onRunningProcess', stage.id);
        }
      }
    }, [_vm._v(" Set Running Process ")]), _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.$emit('onEndStage', stage.id);
        }
      }
    }, [_vm._v(" Set End Stage ")]), _c('b-dropdown-divider'), _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.openUpdateStage(stage);
        }
      }
    }, [_vm._v(" Update Stage ")]), _c('b-dropdown-item', {
      staticClass: "text-danger",
      on: {
        "click": function click($event) {
          return _vm.$emit('onRemoveStage', stage);
        }
      }
    }, [_vm._v(" Delete Stage ")])], 1)], 1), _vm.getStageStatus(stage) ? _c('b-alert', {
      staticClass: "d-dflex align-items-center p-2",
      attrs: {
        "show": "",
        "variant": "primary"
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-circle mr-2"
    }), _vm._v(" This Stage is "), _c('strong', {
      staticClass: "ml-2"
    }, [_vm._v(_vm._s(_vm.getStageStatus(stage)))])]) : _vm._e(), _c('draggable', {
      staticClass: "kanban-tasks-container",
      attrs: {
        "group": {
          name: 'tasks',
          pull: true,
          put: true
        },
        "animation": 150,
        "ghost-class": "ghost-card"
      },
      on: {
        "end": function end($event) {
          return _vm.onTaskMove(stage);
        },
        "add": function add($event) {
          return _vm.onTaskAdded(stage, $event);
        }
      },
      model: {
        value: stage.tasks,
        callback: function callback($$v) {
          _vm.$set(stage, "tasks", $$v);
        },
        expression: "stage.tasks"
      }
    }, [_vm._l(stage.tasks, function (task) {
      var _task$project, _task$project_stage, _task$project_log, _task$project_log$;
      return _c('div', {
        key: task === null || task === void 0 ? void 0 : task.id,
        staticClass: "kanban-card p-3"
      }, [_vm._v(" " + _vm._s(task.title) + " "), _c('div', {
        staticClass: "d-flex justify-content-between align-items-center w-100 mb-2"
      }, [_c('div', {
        staticClass: "text-black text-primary"
      }, [_c('strong', [_vm._v(_vm._s((_task$project = task === null || task === void 0 ? void 0 : task.project) !== null && _task$project !== void 0 ? _task$project : 'Shipment Planning'))])]), _c('b-dropdown', {
        staticClass: "p-0",
        attrs: {
          "size": "lg",
          "variant": "none",
          "no-caret": ""
        },
        scopedSlots: _vm._u([{
          key: "button-content",
          fn: function fn() {
            return [_c('div', {}, [_c('i', {
              staticClass: "fas fa-ellipsis-v text-primary"
            })])];
          },
          proxy: true
        }], null, true)
      }, [_c('b-dropdown-item', {
        attrs: {
          "href": "#",
          "variant": "primary"
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('openSlideFormAddPlan', 'PREVIEW', task === null || task === void 0 ? void 0 : task.id);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-eye mr-2"
      }), _vm._v(" Detail ")]), task !== null && task !== void 0 && task.is_pfa ? _c('b-dropdown-item', {
        attrs: {
          "href": "#",
          "variant": "warning"
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('openPfaSlide', task === null || task === void 0 ? void 0 : task.id);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle mr-2"
      }), _vm._v(" PFA ")]) : _vm._e(), task !== null && task !== void 0 && (_task$project_stage = task.project_stage) !== null && _task$project_stage !== void 0 && _task$project_stage.spal_process ? _c('b-dropdown-item', {
        attrs: {
          "href": "#",
          "variant": "success"
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('openSlideSpalProcess', 'ADD', task === null || task === void 0 ? void 0 : task.id);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-info-circle mr-2"
      }), _vm._v(" Spal Process ")]) : _vm._e(), _c('b-dropdown-item', {
        directives: [{
          name: "b-modal",
          rawName: "v-b-modal.project-approval",
          modifiers: {
            "project-approval": true
          }
        }],
        attrs: {
          "href": "#",
          "variant": "primary"
        }
      }, [_c('i', {
        staticClass: "fa fa-check mr-2"
      }), _vm._v(" Approval ")]), _c('b-dropdown-divider'), _c('b-dropdown-item', {
        attrs: {
          "href": "#",
          "variant": "danger"
        },
        on: {
          "click": function click($event) {
            return _vm.$emit('onDeleteProjectContract', task);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash mr-2"
      }), _vm._v(" Delete ")])], 1)], 1), _c('div', [_c('div', {
        staticClass: "d-flex"
      }, [_vm._v(" Project Type : "), _c('strong', {
        staticClass: "text-muted ml-2"
      }, [_vm._v(" " + _vm._s((task === null || task === void 0 ? void 0 : task.project_type) === 'existing' ? 'Existing' : 'New Project') + " ")])]), _c('div', {
        staticClass: "d-flex"
      }, [_vm._v(" Total Shipment : "), _c('strong', {
        staticClass: "text-muted ml-2"
      }, [_vm._v(" " + _vm._s(task === null || task === void 0 ? void 0 : task.shipment) + " SHIPMENT ")])]), _c('div', {
        staticClass: "d-flex"
      }, [_vm._v(" Capacity : "), _c('strong', {
        staticClass: "text-muted ml-2"
      }, [_vm._v(" " + _vm._s(_vm.formatNumber(task === null || task === void 0 ? void 0 : task.volume)) + " VOLUME ")])])]), _c('div', {
        staticClass: "mt-4 d-flex align-items-center"
      }, [_vm._v(" Periode : "), _c('span', {
        staticClass: "text-sm text-dark ml-2"
      }, [_c('strong', [_vm._v(" " + _vm._s(_vm.moment(task === null || task === void 0 ? void 0 : task.periode_start).format('DD MMM YYYY')) + " ")]), _vm._v(" s/d "), _c('strong', [_vm._v(" " + _vm._s(_vm.moment(task === null || task === void 0 ? void 0 : task.periode_end).format('DD MMM YYYY')) + " ")])])]), _c('small', {
        staticClass: "text-muted text-capitalize text-end"
      }, [_vm._v(" Created by: "), _c('strong', {
        staticClass: "text-primary"
      }, [_vm._v(" " + _vm._s(task === null || task === void 0 ? void 0 : (_task$project_log = task.project_log) === null || _task$project_log === void 0 ? void 0 : (_task$project_log$ = _task$project_log[0]) === null || _task$project_log$ === void 0 ? void 0 : _task$project_log$.name) + " ")])])]);
    }), stage.tasks.length === 0 ? _c('div', {
      staticClass: "empty-drop-zone"
    }, [_vm._v(" Drop tasks here ")]) : _vm._e()], 2)], 1);
  }), 0), _c('div', {
    staticClass: "kanban-column",
    staticStyle: {
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "empty-drop-zone cursor-pointer",
    on: {
      "click": function click($event) {
        _vm.showSidebar = true;
      }
    }
  }, [_vm._m(0)])])], 1) : _vm._e(), _c('CustomSidebar', {
    attrs: {
      "title": _vm.selectedStage ? 'Edit Project Stage' : 'New Project Stage',
      "size": "40%"
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? _c('FormAddProjectStage', {
    attrs: {
      "kanbanData": _vm.kanbanData,
      "selectedData": _vm.selectedStage
    },
    on: {
      "close": function close($event) {
        _vm.showSidebar = false;
      },
      "refetch": function refetch($event) {
        return _vm.$emit('refetch');
      }
    }
  }) : _vm._e()], 1), _c('CustomSidebar', {
    attrs: {
      "title": "New Running Shipment",
      "size": "50%",
      "noCloseOnBackdrop": "",
      "noCloseOnEsc": ""
    },
    model: {
      value: _vm.showSidebarRunning,
      callback: function callback($$v) {
        _vm.showSidebarRunning = $$v;
      },
      expression: "showSidebarRunning"
    }
  }, [_vm.showSidebarRunning ? _c('FormAddRunningShipment', {
    attrs: {
      "kanbanData": _vm.kanbanData,
      "selected-task": _vm.selectedTask
    },
    on: {
      "close": _vm.handleRunningClose,
      "refetch": function refetch($event) {
        return _vm.$emit('refetch');
      },
      "submit": _vm.submitFormAddRunningShipment
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column justify-content-center"
  }, [_c('i', {
    staticClass: "fa fa-plus text-center mr-2",
    staticStyle: {
      "font-size": "24px"
    }
  }), _c('strong', [_vm._v("Add New Stage")])]);

}]

export { render, staticRenderFns }